export default __webpack_public_path__ + "static/media/group-28.229d25c2.svg";